import { routePrefix } from '../../routeInfo';

function getBaseUrl() {
    const { protocol, hostname, port } = window.location;

    return `${protocol}//${hostname}${(process.env.NODE_ENV === 'development' && port) ? `:${port}` : ''}${routePrefix()}`;
}

export default getBaseUrl;
